import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import EditOutlinedIcon from 'components/material-symbol/icons/Edit'
import LinkOutlinedIcon from 'components/material-symbol/icons/Link'
import EventDetailsDialog from '../event-details-dialog'
import EventsActionsMenu from './events-action-menu'
import ShareEventDialog from 'components/group-events/share-event-dialog'
import EventCard from 'components/group-events/event-card'
import { useAuth } from 'lib/auth'
import useStyles from '../styles'
import { getPaymentAccountWarningChip } from '../utils'

const CoachEventCard = ({
  event,
  onPayment,
  extraChip,
  sessionLabel,
  summary,
}) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false)
  const [isShareOpen, setIsShareOpen] = useState(false)
  const { user } = useAuth()
  const classes = useStyles()

  const userIsAssistantCoach = event.assistantCoaches?.some(
    coach => coach.id === user.id,
  )

  const coachCanEdit =
    !event.isCanceled && !event.isPast() && !userIsAssistantCoach

  return (
    <EventCard
      event={event}
      setIsDetailsOpen={setIsDetailsOpen}
      cardActions={
        <>
          {coachCanEdit ? (
            <Tooltip title="Edit">
              <IconButton
                aria-label="Edit"
                component={Link}
                to={`/pga-coach/bookings/events/edit/${event.slug}`}
              >
                <EditOutlinedIcon color="primary" />
              </IconButton>
            </Tooltip>
          ) : null}
          <Tooltip title="Link">
            <IconButton
              aria-label="Link"
              onClick={() => setIsShareOpen(!isShareOpen)}
            >
              <LinkOutlinedIcon color="primary" />
            </IconButton>
          </Tooltip>
          <ShareEventDialog
            isOpen={isShareOpen}
            url={event.eventUrl}
            title={event.title}
            setIsOpen={setIsShareOpen}
            titleText="Share this event with your students"
            eventId={event.id}
          />
          <EventDetailsDialog
            isOpen={isDetailsOpen}
            event={event}
            setIsOpen={setIsDetailsOpen}
            onPayment={onPayment}
          />
        </>
      }
      actionMenu={<EventsActionsMenu setIsDetailsOpen={setIsDetailsOpen} />}
      chip={
        <Box>
          {extraChip}
          {getPaymentAccountWarningChip({ event, classes })}
        </Box>
      }
      sessionLabel={sessionLabel}
      summary={summary}
      showRegistrationClosedChip
    />
  )
}

export default CoachEventCard
